import React from 'react'
import { ConfirmationRoleAction } from '../../../legacy-design-system/action'
import { DialogRenderer } from '../../../legacy-design-system/action/confirmation-action'
import {
  MergeApplicationsDialog,
  MergeApplicationsByFiltersDialog
} from './merge-dialog'
import { Role } from '@contrast-security-inc/base-types'
import { PureQueryOptions } from 'apollo-client'
import { IconMerge } from '@contrast-security-inc/design-system-foundations'
import { ConfirmationRoleActionProps } from '../../../legacy-design-system/action/confirmation-role-action'
import { hasRole } from 'contrastBase/RoleSwitch'

export interface MutationProps {
  readonly organizationID: string
  readonly isFreemium: boolean
  readonly refetchQueries: PureQueryOptions[]
  readonly refresh: () => Promise<any>
}

interface Application {
  readonly id: string
  readonly name: string
  readonly primary: boolean
  readonly archived: boolean
  readonly role: Role
}

interface BulkProps extends MutationProps {
  readonly applications: Application[]
  readonly organizationRole: Role
}

interface BulkWithFiltersProps extends BulkProps {
  readonly excludedApplications: Application[]
  readonly filters: {
    readonly quickFilter: string
    readonly filterText: string
    readonly [key: string]: any
  }
}

interface Props extends Pick<ConfirmationRoleActionProps, 'size'> {
  readonly applications: Application[]
  readonly isFreemium: boolean
  readonly organizationRole: Role
  readonly renderDialog: DialogRenderer
}

function MergeAction({
  applications,
  isFreemium,
  organizationRole,
  renderDialog,
  size
}: Props) {
  return (
    <ConfirmationRoleAction
      size={size}
      data-testid="action_merge"
      isActionValid={
        !isFreemium &&
        applications.length > 1 &&
        applications.filter(({ role }) => hasRole(role, 'EDIT')).length >= 1 &&
        applications.filter(({ primary }) => primary).length <= 1 &&
        !applications.find(({ archived }) => archived)
      }
      role={organizationRole}
      requiredRole="VIEW"
      icon={IconMerge}
      iconTooltipMessage={{ id: 'action_merge', defaultMessage: 'Merge' }}
      renderDialog={renderDialog}
      iconTooltipPlacement="top"
    />
  )
}

export function MergeBulkAction(props: BulkProps) {
  return (
    <MergeAction
      {...props}
      renderDialog={(renderDialogProps) => {
        return <MergeApplicationsDialog {...renderDialogProps} {...props} />
      }}
    />
  )
}

export function MergeBulkWithFiltersAction({
  excludedApplications,
  ...props
}: BulkWithFiltersProps) {
  return (
    <MergeAction
      {...props}
      renderDialog={(renderDialogProps) => {
        return (
          <MergeApplicationsByFiltersDialog
            {...renderDialogProps}
            {...props}
            excludedApplications={excludedApplications.map((app) => app.id)}
          />
        )
      }}
    />
  )
}
